package com.exura.features.firebase.data.serialization

import kotlinx.serialization.modules.SerializersModule

val versionSerializersModule = SerializersModule {
}
